import styled from 'styled-components'

// Components
import { Notes } from '../../../_constants/styles'

// Constants
import colors from '../../../_constants/colors'
import { S_TimeLineNote } from '../TimeLineNote/TimeLineNote.styles'

export const S_NoteList = styled.div`
  h3 {
    ${Notes.headerStyles}
  }

  .note-list {
    display: flex;
    flex-direction: column;
  }

  .note {
    margin-bottom: 16.2px;

    &:last-child {
      ${S_TimeLineNote} {
        .note-container {
          &:before {
            display: none;
          }
        }
      }
    }

    .wrapper {
      color: ${colors.TEXT_DARK};

      &:first-of-type {
        margin-top: 0px;
      }
    }
  }
`
